import React, { Component, Fragment } from 'react'
import { withCookies } from 'react-cookie'
import { withStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import Toolbar from '@material-ui/core/Toolbar';
import SyncIcon from '@material-ui/icons/Sync';
import ClearIcon from '@material-ui/icons/Clear';
import AddIcon from '@material-ui/icons/Add';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Link from '@material-ui/core/Link';
import Box from '@material-ui/core/Box';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import CustomCircularProgress from '../../../custom/CustomCircularProgress';
import PermissionsApi from '../../../../libs/EdgeVMSCloudApi/Permissions'
import RoleApi from '../../../../libs/EdgeVMSCloudApi/Roles'
import { SERVICES, OPERATIONS } from '../../../../constants/permissions'
import CustomTable from '../../../custom/CustomTable';
import CustomTableHead from '../../../custom/CustomTableHead';
import SearchBox from '../../../custom/SearchBox'
import { GetNavParamsFromLocation } from '../../../../libs/Utils'
import { NavTableFooter } from '../../../table'
import ROWS_PER_PAGE_OPTIONS from '../../../../constants/navParams'
import { COOKIES } from '../../../../constants/cookieDefs'
import { ConfirmAction, SelectPermissionDialog } from '../../../dialogs'

const useStyles = theme => ({
  root: {
    width: '100%',
    overflowX: 'auto',
    display: 'flex',
  },
  container: {
    paddingTop: theme.spacing(0),
    paddingBottom: theme.spacing(4),
  },
  title: {
    flexGrow: 1,
    color: theme.palette.secondary.main,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 240,
  },
  actionsCell: {
    textAlign: 'center',
    whiteSpace: 'nowrap',
  },
});

class RolePermissionsTab extends Component {
  constructor (props) {
    super(props)

    const { cookies } = props;
    const DefaultNavParams = {
      currentPage: '0',
      rowsPerPage: cookies.get(COOKIES.ROWS_PER_PAGE.name),
      searchString: "",
    }

    this.state = {
      isLoading: true,
      showActionProgress: false,
      confirmDeleteActionOpen: false,
      selectPermissionDialogOpen: false,
      role: {},
      rolePermissions : {},
      systemPermissions: [],
      hasDataError: false,
    }

    this.idInAction = null
    this.navParams = GetNavParamsFromLocation(DefaultNavParams)
    this.abortController = new AbortController();
    this.signal = this.abortController.signal;
  }

  async componentDidMount () {
    await this.handleRefresh()
  }

  componentWillUnmount () {
    this.abortController.abort();
  }

  async handleRefresh () {
    if (!this.props.newRole && this.props.match.params.role) {
      this.setState({isLoading: true})

      let response = await RoleApi.FetchRole(this.signal, this.props.match.params.role)
      if (response.error && response.error.name === "AbortError") {
        return;
      }

      this.setState ({role: response.ok ? response.body : {}})

      if (response.ok) {
        response = await RoleApi.FetchRolePermissions(this.signal, this.props.match.params.role, this.navParams)
        if (response.error && response.error.name === "AbortError") {
          return;
        }

        this.setState({rolePermissions: response.ok ? response.body : {}})
      } else {
        this.setState({rolePermissions: {}})
      }

      if (response.ok) {
        response = await PermissionsApi.FetchPermissionActions(this.signal)
        if (response.error && response.error.name === "AbortError") {
          return;
        }

        this.setState({systemPermissions: response.ok ? response.body : []})
      } else {
        this.setState({systemPermissions: []})
      }

      this.setState({hasDataError: response.error ? true : false}, () => this.setState({isLoading: false}))
    } else {
      this.setState({isLoading: false})
    }
  };

  handleRequestSearch (event, value) {
    let currentParams = new URLSearchParams(window.location.search)
    currentParams.set('currentPage', '0')

    if (value.length) {
      currentParams.set('searchString', value)
    } else {
      currentParams.delete('searchString')
    }

    window.location.search = currentParams.toString()
  };

  onDeleteActionClick (idInAction) {
    if (idInAction)
    {
      this.idInAction = idInAction
      this.setState({showActionProgress: false})
      this.setState({confirmDeleteActionOpen: true})
    }
  }

  async DeleteActionCallback (userAnswer, toDelete) {

    if (userAnswer && userAnswer === 'ok' && toDelete && toDelete.id) {
      this.setState({showActionProgress: true})

      let response = await RoleApi.DeassignPermission(this.signal, this.props.match.params.role, toDelete.id)
      if (response.error && response.error.name === "AbortError") {
        return;
      }

      await this.handleRefresh()
    }

    this.setState({confirmDeleteActionOpen: false})
  };


  render () {
    const { classes, session, newRole } = this.props
    const { isLoading, role, rolePermissions, systemPermissions, hasDataError } = this.state
    const { currentPage, rowsPerPage, searchString } = this.navParams
    const originLocation = this.props.location.state ? this.props.location.state.originLocation : undefined
    const hasUpdatePermission = session.permissions[SERVICES.USER][OPERATIONS.UPDATE]

    if (newRole) {
      return null
    }

    let { total, offset, permissions } = rolePermissions
    if (permissions == null) {
      permissions = []
    }

    if (total == null) {
      total = 0
    }

    if (offset == null) {
      offset = 0
    }

    return (
      <div className={classes.root}>
        <Container maxWidth="md" className={classes.container}>
          <Toolbar>
            <Breadcrumbs separator={<NavigateNextIcon fontSize="small"/>} color="inherit" aria-label="breadcrumb" className={classes.title}>
              <Link component="button" variant="h6" href="/" color="inherit" title='Back To Roles'
                onClick={() => originLocation ? window.location.href = originLocation : this.props.history.push('/mainmenu/admin/roles')}
              >
                Roles
              </Link>
              { role.name &&
                <Link component="button" variant="h6" href="/" color="inherit" title='Back to Details'
                  onClick={() => this.props.history.push(this.props.location.pathname.substring(0, this.props.location.pathname.lastIndexOf('/')), this.props.location.state)}
                >
                  { role.name }
                </Link>
              }
              { role.name &&
                <Typography component="h1" variant="h6" color="inherit" noWrap>
                  Permissions
                </Typography>
              }
            </Breadcrumbs>

            <Tooltip title="Back">
              <span>
                <IconButton id="go-back-icon" disabled={isLoading} onClick={this.props.history.goBack.bind(this)}>
                  <ArrowBackIcon />
                </IconButton>
              </span>
            </Tooltip>
            { hasUpdatePermission &&
              <Tooltip title={"Add Permission"}>
                <span>
                  <IconButton id="add-permission-icon" disabled={isLoading || hasDataError} onClick={() => this.setState({selectPermissionDialogOpen: true})}>
                    <AddIcon />
                  </IconButton>
                </span>
              </Tooltip>
            }
            <Tooltip title="Refresh">
              <span>
                <IconButton id="refresh-icon" disabled={isLoading} onClick={this.handleRefresh.bind(this)}>
                  <SyncIcon />
                </IconButton>
              </span>
            </Tooltip>
          </Toolbar>
          <Box display="flex" justifyContent="flex-end">
            <SearchBox
              className={classes.formControl}
              disabled={isLoading}
              onSearch={this.handleRequestSearch.bind(this)}
              searchString={searchString}
            />
          </Box>
          { isLoading ? (
            <CustomCircularProgress />
          ) : (
            <Fragment>
              <CustomTable>
                <CustomTableHead>
                  <TableRow selected={true}>
                    <TableCell>Permission</TableCell>
                    <TableCell>Service</TableCell>
                    <TableCell>Operation</TableCell>
                    <TableCell>Scope</TableCell>
                    { hasUpdatePermission &&
                      <TableCell align="center">Actions</TableCell>
                    }
                  </TableRow>
                </CustomTableHead>
                {permissions.length ? (
                  <TableBody>
                    {permissions.map((permission) => {
                      const systemPermission = systemPermissions.find(systemPermission => (permission.service === systemPermission.service) && (permission.operation === systemPermission.operation))
                      return (
                        <TableRow hover key={permission.id}>
                          <TableCell title={systemPermission && systemPermission.description}>
                            {systemPermission && systemPermission.name}
                          </TableCell>
                          <TableCell title={systemPermission && systemPermission.description}>
                            {permission.service}
                          </TableCell>
                          <TableCell title={systemPermission && systemPermission.description}>
                            {permission.operation}
                          </TableCell>
                          <TableCell title={systemPermission && systemPermission.description}>
                            {permission.rescource}
                          </TableCell>
                          { hasUpdatePermission &&
                            <TableCell className={classes.actionsCell}>
                              <Tooltip title="Remove From Role">
                                <IconButton
                                  size={'small'}
                                  onClick={this.onDeleteActionClick.bind(this, {permission, systemPermission})}
                                >
                                  <ClearIcon fontSize={'small'} />
                                </IconButton>
                              </Tooltip>
                            </TableCell>
                          }
                        </TableRow>
                    )})}
                  </TableBody>
                ) : (
                  <TableBody>
                    <TableRow>
                      <TableCell align='center' colSpan={hasUpdatePermission ? 5 : 4}>No Permissions Assigned</TableCell>
                    </TableRow>
                  </TableBody>
                )}
                <NavTableFooter
                  labelRowsPerPage='Permissions per page'
                  rowsPerPageOptions={ROWS_PER_PAGE_OPTIONS}
                  count={total}
                  rowsPerPage={parseInt(rowsPerPage, 10)}
                  currentPage={total > 0 ? parseInt(currentPage, 10) : 0}
                />
              </CustomTable>
            </Fragment>
          )}
        </Container>

        <SelectPermissionDialog
          open={this.state.selectPermissionDialogOpen === true}
          session={session}
          parentRole={role}
          doneCallback={() => this.setState({selectPermissionDialogOpen: false}, () => this.handleRefresh())}
        />

        <ConfirmAction
          title="Remove Permission From Role ?"
          open={this.state.confirmDeleteActionOpen === true}
          showProgress={this.state.showActionProgress}
          progressMsg="Processing request to remove permission from role..."
          actionCallback={this.DeleteActionCallback.bind(this)}
          callbackContext={this.idInAction ? this.idInAction.permission : undefined}
        >
          {`Are you sure you want to remove ${this.idInAction && this.idInAction.systemPermission && this.idInAction.systemPermission.name ? "\"" + this.idInAction.systemPermission.name + "\"" : "this"} permission from "${role.name}" role ?`}
        </ConfirmAction>

      </div>
    )
  }
}

export default withCookies(withStyles(useStyles)(RolePermissionsTab))
